import { render, staticRenderFns } from "./BetgameUsersTable.vue?vue&type=template&id=5677d39b&scoped=true"
import script from "./BetgameUsersTable.vue?vue&type=script&lang=js"
export * from "./BetgameUsersTable.vue?vue&type=script&lang=js"
import style0 from "./BetgameUsersTable.vue?vue&type=style&index=0&id=5677d39b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677d39b",
  null
  
)

export default component.exports